import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Divider,
  Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { BrandButton, TextCancelButton } from '../button';

const closeIconSx = { position: 'absolute', right: 8, top: 8 };

/**
 * Shared dialog frame: title + close, dividers, standard actions (privacy / cancel / save).
 */
export default function CookieSettingsDialogChrome({
  open,
  onClose,
  titleId = 'cookie-preferences-dialog',
  onViewPolicy,
  onSave,
  saveLabel = 'Save Settings',
  children
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      aria-labelledby={titleId}
    >
      <DialogTitle id={titleId}>
        Cookie Settings
        <IconButton aria-label="close" onClick={onClose} sx={closeIconSx}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent>{children}</DialogContent>
      <Divider />
      <DialogActions sx={{ padding: 2, justifyContent: 'space-between' }}>
        <BrandButton tone="accent" onClick={onViewPolicy}>
          Privacy Policy
        </BrandButton>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <TextCancelButton onClick={onClose}>
            Cancel
          </TextCancelButton>
          <BrandButton tone="accent" onClick={onSave}>
            {saveLabel}
          </BrandButton>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
